import styled, { css } from 'styled-components';
import { matchString } from '~/utilities/matchers';
import type { Directions } from './types';

export const TOOLTIP_WIDTH = 270;

export const StoryContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 200px 0;
`;

export const tooltipTopStyle = css<{ isAbsolute: boolean }>`
  left: 50%;
  padding: 8px 0;
  top: 0;
  transform: translate(${({ isAbsolute }) => (isAbsolute ? '0' : '-50%')}, -100%);
`;

export const tooltipBottomStyle = css<{ isAbsolute: boolean }>`
  bottom: 0;
  left: 50%;
  padding: 8px 0;
  transform: translate(${({ isAbsolute }) => (isAbsolute ? '0' : '-50%')}, 100%);
`;

export const tooltipLeftStyle = css`
  left: 0;
  padding: 0 8px;
  top: 0;
  transform: translateX(-100%);
`;

export const tooltipRightStyle = css`
  padding: 0 8px;
  right: 0;
  top: 0;
  transform: translateX(100%);
`;

export const tooltipStyle = css`
  background: white;
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme.shadow.elevation2};
  max-width: ${TOOLTIP_WIDTH}px;
  padding: 16px;
`;

export const Footer = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TooltipContainer = styled.div<{
  active: boolean;
  direction?: Directions;
  isAbsolute: boolean;
}>`
  display: ${({ active }) => (active ? 'block' : 'none')};
  position: absolute;
  z-index: ${({ theme }) => theme.zIndex.Tooltip};
  ${({ direction }) =>
    direction &&
    matchString(direction)({
      top: () => tooltipTopStyle,
      bottom: () => tooltipBottomStyle,
      left: () => tooltipLeftStyle,
      right: () => tooltipRightStyle,
    })}
`;

export const StyledTooltip = styled.div<{ onboardingRedesign?: boolean }>`
  ${tooltipStyle}
  width: ${TOOLTIP_WIDTH}px;
  ${({ onboardingRedesign }) =>
    onboardingRedesign &&
    `
    margin: 0 25px;
  `}
`;

export const StepCounter = styled.div`
  color: black;
  font-size: 14px;
  text-align: left;
`;
